<template>

    <LayoutDefault>

       <b-row v-if="!emailSend" class="fuid-login">

            <b-col cols="12 fuid-login_error">

                <errorFromServer
                    :id="id"
                />

            </b-col>

            <b-col cols="12"
                class="fuid-form-group"
                :class="{ 'form-group--error': $v.fields.email.$error }"
            >

                <label class="fuid-form__label">{{$t('login.newpassword')}}</label>
                <input class="fuid-form__input" v-model.trim="$v.fields.email.$model" />
                <div class="error" v-if="!$v.fields.email.required">{{$t('forms.required')}}</div>
                <div class="error" v-if="!$v.fields.email.email">{{$t('forms.email')}}</div>

            </b-col>

            <b-col cols="12" class="d-flex justify-content-between align-items-center fuid-form__actions">

                <button class="fuid-button fuid-button-step align-items-center" @click.prevent="regenerate()">
                    
                    <b-spinner v-if="loading" variant="light" label="Loading..."></b-spinner>
                    <span v-else>{{$t('login.send')}}</span>
                    
                </button>

                <button class="fuid-button fuid-button-step align-items-center" @click.prevent="toLogin()">

                    {{ $t("login.back") }}

                </button>

            </b-col>

        </b-row>

        <b-row v-else class="fuid-login-ok">

            <b-col cols="12" class="py-4">

                <h4 class="fuid-resu-tit text-center">{{ $t('forms.emailok') }}</h4>

                <p class="text-center">{{ $t('forms.emailoktray') }}</p>

            </b-col>

        </b-row>

    </LayoutDefault>

</template>

<script>

    import { mapActions } from 'vuex'
    import { mapGetters } from 'vuex'

    import { required, email } from "vuelidate/lib/validators"
    import LayoutDefault from '@/components/layouts/LayoutDefault'
    import errorFromServer from '@/components/errorFromServer'

    export default {

        data() {

            return {

                id: 2,
                logged: false,
                loading: false,
                validation_form: false,
                emailSend: false,
                fields: {

                    email: ''

                }

            }

        },

        validations: {

            fields: {

                email: {
                    required,
                    email
                }

            }

        },

        components: {

            LayoutDefault,
            errorFromServer

        },

        methods: {

            ...mapActions('Login', ['loginUser']),
            ...mapActions('Login', ['newPassWordPlease']),

            /*
            * Send user data
            *
            */
            async regenerate () {

                this.$v.$touch()

                if (this.$v.$invalid) {
                    
                    this.validation_form = false

                } else {
                    
                    this.validation_form = true

                }

                if( this.validation_form ) {

                    this.loading = true
                    
                    let logToken = await this.loginUser( { username: process.env.VUE_APP_API_USER, password: process.env.VUE_APP_API_PASSWORD, componentId: this.id } )
                    let newpassword = await this.newPassWordPlease( { email: this.fields.email, locale: this.$i18n.locale , componentId: this.id } )

                    this.loading = false

                    if( newpassword ) {

                        this.emailSend = true
                        localStorage.removeItem('logged')

                    }

                }

            },

            /*
            * Empty login form
            *
            */
           resetForm() {

               this.fields.email = ''

           },

           /*
            * Router to login
            *
            */
           toLogin() {

               this.$router.push(`/${this.$i18n.locale}`)

           }

        }
        
    }

</script>